// public/v3/src/lib/use-unsaved-changes-guard-logic.js — pure dirty-state
// detection for v3 modals.
//
// Compares a current form state against an initial snapshot taken at modal
// open time. Returns true iff any key in `initial` has a different value in
// `current`. Keys present in `current` but not `initial` are ignored (we only
// track what the modal declared at mount).
//
// Pure function — no React. CommonJS so Jest can read it directly.
//
// The React hook that consumes this (use-unsaved-changes-guard.js) wraps it
// with useRef + useMemo. The hook is not Jest-readable because it imports
// React; this file isolates the logic so the comparison rule is unit-testable
// in isolation.

function computeDirty(initial, current) {
  if (!initial) return current ? Object.keys(current).length > 0 : false;
  if (!current) return Object.keys(initial).length > 0;
  for (const key of Object.keys(initial)) {
    if (initial[key] !== current[key]) return true;
  }
  return false;
}

module.exports = { computeDirty };
